export default [
  {
    path: "/",
    name: "index",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    meta: {
      auth: [1],
    },
    component: () => import("@/views/Home/index.vue"),
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/Index/index.vue"),
      },
      {
        path: "/game",
        name: "game",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/Game/index.vue"),
      },
      {
        path: "/recharge",
        name: "recharge",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/Recharge/index.vue"),
      },
      {
        path: "/customer",
        name: "customer",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/Customer/index.vue"),
      },
      {
        path: "/aboutUS",
        name: "aboutUS",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/AboutUS/index.vue"),
      },
      {
        path: "/news",
        name: "news",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/News/index.vue"),
      },
      {
        path: "/news2",
        name: "news2",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/News/news2.vue"),
      },
      {
        path: "/news3",
        name: "news3",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/News/news3.vue"),
      },
      {
        path: "/agreement",
        name: "agreement",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/Agreement/index.vue"),
      },
      {
        path: "/intergame",
        name: "intergame",
        meta: {
          auth: [1],
        },
        component: () => import("@/views/Agreement/intergame.vue"),
      },
    ],
  },
];
